<template>
  <div class="invoice-info">
    <div class="invoice-info-main">
      <p>发票抬头：{{ list.title }}</p>
      <p>开具类型：{{['普通发票', '增值税发票', '电子普通发票','','全电普通发票','全电专用发票'][list.type]}}</p>
      <p>税务证号：{{ list.tax_id }}</p>
      <p>开户银行：{{ list.bank }}</p>
      <p>开户账号：{{ list.account }}</p>
      <p>注册地址：{{ list.address }}</p>
      <p>注册电话：{{ list.phone }}</p>
      <p>开具邮箱：{{list.email}}</p>
    </div>
    <div class="invoice-change-info">
      <span @click="changeInfo()">{{list.title ? '' :'添加发票信息'}}</span>
    </div>
    <div class="show" v-if='flag'>
      <head v-if='flag'>
        <span class="span">添加发票信息</span>
        <span class="notshow" @click="notchangeInfo()">X</span>
      </head>
      <div class="line"></div>
      <p class="zhu">
        <span
          >(  注：*是必填项 资料请慎重填写，一旦提交后将不能更改，如需更改，请联系客服!  )</span
        >
      </p>
      <div class="main">
        <div>
          <span><i>*</i> 开票类型</span>
          <select v-model="list.type"  class="selectcommuity">
            <option value="">请选择</option>
            <option v-for="(item,index) of typeList" :label="item.name" :value="item.value" :key="index">{{item}}</option>
          </select>
        </div>
        <div>
          <span><i>*</i> 开票抬头</span>
          <input
            type="text"
            v-model="list.title"
            placeholder="请输入开票抬头"
          />
        </div>
        <div>
          <span><i>*</i> 税号</span>
          <input
            type="text"
            v-model="list.tax_id"
            placeholder="请输入税号"
          />
        </div>
        <div>
          <span><i v-if="list.type == 1 || list.type == 5">*</i> 开户行</span>
          <input
            type="text"
            v-model="list.bank"
            placeholder="请输入开户行"
          />
        </div>
        <div>
          <span><i v-if="list.type == 1|| list.type == 5">*</i> 银行账号</span>
          <input
            type="text"
            v-model="list.account"
            placeholder="请输入银行账号"
          />
        </div>
        <div>
          <span><i v-if="list.type == 1|| list.type == 5">*</i> 开票地址</span>
          <input
            type="text"
            v-model="list.address"
            placeholder="请输入开票地址"
          />
        </div>
        <div>
          <span><i v-if="list.type == 1|| list.type == 5">*</i> 开票电话</span>
          <input
            type="text"
            v-model="list.phone"
            placeholder="请输入开票电话"
          />
        </div>
        <div>
          <span><i>*</i> 电子邮箱</span>
          <input
            type="text"
            v-model="list.email"
            placeholder="请输入接受电子发票的邮箱"
          />
        </div>
      </div>
      <div class="btns">
        <button class="cancel" @click="notchangeInfo()">取消</button>
        <button class="save" @click="save()">保存</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      flag: false,
      list: [],
      typeList:[{
        name:'普通发票',
        value:0
      },{
        name:'全电普通发票',
        value:4
      },{
        name:'全电专用发票',
        value:5
      }]
    };
  },
  methods: {
    changeInfo() {
      this.flag = true;
    },
    notchangeInfo() {
      this.flag = false;
    },
    save() {
      this.$api.invoice
        .saveinvoice({
          ...this.list,
        })
        .then((res) => {
          if (res.status == 1) {
            this.flag = false;
          }else{
            if(this.list.account !== ""){
              this.$message.warning('提交后将不能更改，如需更改，请联系客服!')
            }
          }
      });
    },
  },
  created() {
    this.$api.invoice.getinvoice({}).then((res) => {
      let data = res.data;
      if (data) {
        this.list = res.data;
      } else {
        this.list = []
      }
    });
  },
};
</script>

<style lang="scss" scoped>
*{
  font-size: 15px;
}

.invoice-change-info{
   color: #A52A2A;
   margin-left: 21px;
    line-height: 36px;
}
.invoice-info-main {
  font-size: 12px;
  color: #333333;
  margin-left: 21px;
  p{
    margin: 15px 0px;
  }
}
.show {
  width: 620px;
  background: #ffffff;
  box-shadow: 0px 0px 26px 0px rgba(205, 205, 205, 0.5);
  position: fixed;
  left:50%;
  top:50%;
  transform: translate(-50%,-50%);
  head {
    width: 100%;
    height: 52px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .span {
      font-size: 14px;
      color: #333333;
      margin-left: 21px;
    }
    .notshow {
      opacity: 0.99;
      color: #999999;
      margin-right: 24px;
      cursor: pointer;
    }
  }
  .line {
    width: 576px;
    height: 1px;
    border: 1px solid #f1f2f3;
    margin: auto;
  }
  .zhu {
    font-size: 16px;
    margin: 10px;
    text-align: center;
    span {
      font-size: 12px;
      color:  #A52A2A;
    }
  }
  .main {
    div {
      display: flex;
      margin-top: 20px;
      font-size: 18px;
      flex-wrap: wrap;
      height:30px;
      .p {
        color:  #A52A2A;
        font-size: 12px;
        margin: auto;
      }
      p {
        margin-left: 16px;
      }
      span {
        width: 142px;
        height: 24px;
        text-align: right;
        line-height: 24px;
        letter-spacing: 0px;
        margin-left: 24px;
        i {
          color:  #A52A2A;
          font-style: normal;
        }
      }
      input , select{
        width: 422px;
        height: 30px;
        border: 0px;
        background: #ffffff;
        border-radius: 3px;
        border: 1px solid #ccc;
        margin-left: 16px;
      }
    }
  }
  .btns {
    margin-top: 30px;
    button {
      width: 80px;
      height: 30px;
      border: 0px;
      margin-bottom: 22px;
    }
    .cancel {
      margin-left: 430px;
      background: #fff;
      color: #ccc;
      border: 1px solid #ccc;
    }
    .save {
      margin-left: 10px;
      background: #ffbb00;
      color: #003871;
    }
  }
}
</style>